module.exports = __webpack_public_path__ + "static/media/bottom_waves.a28a3fe8.png";